import { render, staticRenderFns } from "./orderTcCgApprove.vue?vue&type=template&id=15abc98b&scoped=true"
import script from "./orderTcCgApprove.vue?vue&type=script&lang=js"
export * from "./orderTcCgApprove.vue?vue&type=script&lang=js"
import style0 from "./orderTcCgApprove.vue?vue&type=style&index=0&id=15abc98b&prod&scoped=true&lang=css"
import style1 from "./orderTcCgApprove.vue?vue&type=style&index=1&id=15abc98b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15abc98b",
  null
  
)

export default component.exports